export const WHOLESALE_BOTTLE_SHOP_SPECIAL_USER_ID = 'bottle_shop_opt_client_work_around';

export const WHOLESALE_BOTTLE_SHOP_HOSTS = [
    'whs.bottle-shop.me',
];

function normalizeHostname(hostname: string): string {
    return hostname.trim().toLowerCase();
}

export function isWholesaleBottleShopHost(hostname: string): boolean {
    return WHOLESALE_BOTTLE_SHOP_HOSTS.includes(normalizeHostname(hostname));
}

export function isSimpleOrderPlacementHost(hostname: string): boolean {
    return isWholesaleBottleShopHost(hostname);
}

export function isWholesaleBottleShopOrigin(origin: string): boolean {
    try {
        return isWholesaleBottleShopHost(new URL(origin).hostname);
    } catch {
        return isWholesaleBottleShopHost(origin);
    }
}

/**
 * Bottle Shop wholesale domains receive a backend-personalized menu through a
 * special request user. The frontend must therefore expose full stock there
 * even when no explicit price_level was hydrated into local user state.
 */
export function shouldShowFullStockOnMenu(hostname: string, isSpecialPriceLevelUser: boolean): boolean {
    return isSpecialPriceLevelUser || isWholesaleBottleShopHost(hostname);
}

export function resolveMenuRequestUserIdForHost(hostname: string, userId: string | null): string | null {
    if (isWholesaleBottleShopHost(hostname)) {
        return WHOLESALE_BOTTLE_SHOP_SPECIAL_USER_ID;
    }

    return userId && userId.trim().length > 0 ? userId : null;
}
